import { default as deleteKeyConfiguration } from './deleteKey';
import { default as generateBusinessKeyConfiguration } from './generateBusinessKey';
import { default as generateKeyConfiguration } from './generateKey';
import { default as getBusinessKeysConfiguration } from './getBusinessKeys';
import { default as getKeysConfiguration } from './getKeys';

export const configurations = [
  getKeysConfiguration,
  getBusinessKeysConfiguration,
  generateKeyConfiguration,
  generateBusinessKeyConfiguration,
  deleteKeyConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/api-key/configurations/index.js